// Canonical column ids are lower_snake — the case the server's camera column
// registry uses and the physical case in ClickHouse. UPPER_SNAKE is only the
// alias the query builder invents, and it is what query-result column names and
// `common:columnNames.*` keys carry. The two conventions meet here so the
// mapping is a named contract rather than scattered case changes.

export const toColumnId = (name: string): string => name.toLowerCase();

export const toColumnName = (id: string): string => id.toUpperCase();
